<template>
    <v-container fluid class="px-0" id="jumbotron">
        <v-row no-gutters align="stretch">
            <v-col md="9" class="d-none d-md-flex">
                <v-img eager alt="Banner" src="@/assets/images/homepage/banner1.png"></v-img>
            </v-col>
            <v-col md="3" class="white">
                <v-tabs v-model="authTab" grow>
                    <v-tab>Masuk</v-tab>
                    <v-tab>Daftar</v-tab>
                </v-tabs>

                <v-tabs-items v-model="authTab">
                    <v-tab-item>
                        <login-form></login-form>
                    </v-tab-item>
                    <v-tab-item>
                        <signup-form></signup-form>
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { sync } from 'vuex-pathify'

import LoginForm from '@/components/home/LoginForm'
import SignupForm from '@/components/home/SignupForm'

export default {
    components: {
        LoginForm,
        SignupForm,
    },

    computed: {
        authTab: sync('home/authTab')
    }
}
</script>
